import { render, staticRenderFns } from "./NewsCategories.vue?vue&type=template&id=ee7f4d14&scoped=true"
import script from "./NewsCategories.vue?vue&type=script&lang=js"
export * from "./NewsCategories.vue?vue&type=script&lang=js"
import style0 from "./NewsCategories.vue?vue&type=style&index=0&id=ee7f4d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7f4d14",
  null
  
)

export default component.exports